import { render, staticRenderFns } from "./Head.vue?vue&type=template&id=6aead23e&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"
import style0 from "./Head.vue?vue&type=style&index=0&id=6aead23e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aead23e",
  null
  
)

export default component.exports